function removeMapsScriptsFromHead() {
    const googleScriptsList = document.querySelectorAll('script[src*="maps.googleapis.com"],script[src*="apis.google.com"]');
    for (const elem of googleScriptsList) {
        elem.remove();
    }
}

export const sleep = (milliseconds) => {
    return new Promise((resolve, reject) => {
        let wait = setTimeout(() => {
            clearTimeout(wait);
            resolve('done');
        }, milliseconds)
    })
}

export const hasSomeParentClass = (element, classname) => {
    try {
        if ([...element?.classList || []].indexOf(classname) >= 0) return true;
        return element.parentNode && hasSomeParentClass(element.parentNode, classname);
    } catch (e) {
        console.log({element, classname})
        console.log(e);
    }
}

function eventDurationString(event) {
    const add_minutes = 20;
    const {conversation_duration, conversation_users_count, seats_min, seats_max} = event;
    const min_time = (seats_min / conversation_users_count * conversation_duration) + add_minutes;
    const max_time = (seats_max / conversation_users_count * conversation_duration) + add_minutes;
    const min_time_obj = {
        hours: Math.floor(min_time / 60),
        minutes: Math.floor(min_time % 60)
    };
    const max_time_obj = {
        hours: Math.floor(max_time / 60),
        minutes: Math.floor(max_time % 60)
    };
    if (min_time_obj.hours) {
        return `${(min_time / 60).toFixed(1)} - ${(max_time / 60).toFixed(1)} hour${max_time_obj.hours > 1 ? 's' : ''}`;
    } else if (max_time_obj.hours) {
        return `${min_time_obj.minutes} min - ${(max_time / 60).toFixed(1)} hour${max_time_obj.hours > 1 ? 's' : ''}`;
    } else {
        return `${min_time_obj.minutes} - ${max_time_obj.minutes} min`;
    }
}

export { removeMapsScriptsFromHead, eventDurationString };

export const downloadFile = (
    href,
    name = `${new Date().getTime().toString(32)}-file.csv`
) => {
    const link = document.createElement('a')
    link.href = href
    link.setAttribute('download', name)
    document.body.appendChild(link)
    link.click()

    // clean up "a" element & remove ObjectURL
    document.body.removeChild(link)
    URL.revokeObjectURL(href)
}
